import { useEffect, useState } from 'react'

import { Checkbox } from 'primereact/checkbox'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Button, Icon, Modal, notification, Tooltip } from 'antd'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'

import AlertIcon from '../../../../assets/images/ico_erro.svg'
import { api, request } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'
const { confirm } = Modal

const ListAlternatives = ({ groupId }) => {
  const [alternatives, setAlternatives] = useState([])
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    if (groupId) {
      fetchAlternatives(groupId)
    }
  }, [groupId, isLoad])

  const fetchAlternatives = async (groupId) => {
    setIsLoad(false)
    const response = await request(api.findAlternativesByGroupId(groupId), false, true)
    setAlternatives(response)
  }

  function showConfirm(onDeleteFunc, message) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: 10
        }
      },
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      onOk() {
        if (onDeleteFunc) {
          onDeleteFunc()
        }
      },
      onCancel() {}
    })
  }

  async function deleteAlternativeDocuments(alternativeId, customerGroupId) {
    try {
      await api.removeAlternativeFromGroup(alternativeId, customerGroupId)
      notification.success({
        description: getMessage('removeAlternateSuccess'),
        message: getMessage('sweetAlerts.success')
      })
      setIsLoad(true)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function updateCustomerAlternativeDocumentsOriginal(alternativeId) {
    try {
      await api.updateCustomerAlternativeDocumentsOriginal(alternativeId, groupId)
      setIsLoad(true)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  const originalTemplate = ({ id, original }) => {
    return (
      <Checkbox
        onChange={() =>
          showConfirm(() => {
            updateCustomerAlternativeDocumentsOriginal(id)
          }, 'alternativeOriginalChange')
        }
        checked={original}
      ></Checkbox>
    )
  }

  const statusTemplate = ({ approvalStatus }) => {
    return (
      <>
        <i
          className="pi pi-circle-fill"
          style={{ color: approvalStatus === 'Aprovado' ? '#505673' : 'rgb(255, 180, 11)' }}
        ></i>
        <span style={{ color: 'black', marginLeft: 2 }}>{approvalStatus}</span>
      </>
    )
  }

  const alternativesTemplate = ({ id }) => {
    return (
      <Tooltip title={'Remover alternativo do grupo'}>
        <Button onClick={() => showConfirm(() => deleteAlternativeDocuments(id, groupId))}>
          <Icon type="delete" size="small" />
        </Button>
      </Tooltip>
    )
  }

  return (
    <div>
      <DataTable value={alternatives} responsiveLayout="scroll">
        <Column field="original" header={getMessage('original')} body={originalTemplate} style={{ minWidth: '10%' }} />
        <Column field="partnerName" header={getMessage('alternateName')} style={{ minWidth: '35%' }} />
        <Column
          field="approval"
          header={getMessage('alternateStatus')}
          body={statusTemplate}
          style={{ minWidth: '35%' }}
        />
        <Column field="documentNumber" header={getMessage('document')} style={{ minWidth: '35%' }} />
        <Column
          field="date"
          header={getMessage('label.actions')}
          body={alternativesTemplate}
          style={{ minWidth: '10%' }}
        />
      </DataTable>
    </div>
  )
}

export default ListAlternatives
